<template>
  <div class="addCommentShareRule">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>商品</el-breadcrumb-item>
      <el-breadcrumb-item>评价</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/commentShareRuleList' }">评价共享管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{ isEdit ? '编辑' : '新建' }}规则</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="boxLayout">
      <h3 class="title-t mg-b-30">基础信息</h3>

      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="规则名称" prop="rule_name">
          <el-input
            v-model="form.rule_name"
            placeholder="请输入规则名称"
            maxlength="255"
            show-word-limit
            style="width: 400px"
          ></el-input>
        </el-form-item>

        <el-form-item label="规则描述" prop="description">
          <el-input
            v-model="form.description"
            type="textarea"
            :rows="3"
            placeholder="请输入规则描述（选填）"
            maxlength="255"
            show-word-limit
            style="width: 400px"
          ></el-input>
        </el-form-item>

        <el-form-item label="规则状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
          <div class="tips">禁用状态的规则不会生效，商品评价不会被共享</div>
        </el-form-item>

        <el-form-item label="关联商品">
          <el-button type="primary" size="small" @click="openGoodsDialog">
            + 选择商品
          </el-button>
          <span class="mg-l-20 tips">已选择 {{ selectedGoods.length }} 个商品</span>
        </el-form-item>

        <el-form-item v-if="selectedGoods.length > 0">
          <el-table :data="selectedGoods" border max-height="400" style="width: 900px">
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>

            <el-table-column label="商品名称" min-width="280">
              <template slot-scope="scope">
                <div class="goods-cell">
                  <el-image
                    v-if="scope.row.image"
                    :src="scope.row.image"
                    class="goods-image"
                    fit="cover"
                  ></el-image>
                  <div class="goods-name">{{ scope.row.name }}</div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="商品UUID" min-width="280">
              <template slot-scope="scope">
                <span class="text-gray">{{ scope.row.uuid }}</span>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="100" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  style="color: #f56c6c"
                  @click="removeGoods(scope.$index)"
                >
                  移除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSubmit" :loading="submitting">保存</el-button>
          <el-button @click="$router.back()">取消</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 商品选择弹窗 -->
    <el-dialog
      title="选择商品"
      :visible.sync="goodsDialogVisible"
      width="70%"
      :close-on-click-modal="false"
    >
      <div class="goods-search">
        <el-input
          v-model="goodsKeyword"
          placeholder="请输入商品名称搜索"
          style="width: 300px"
          clearable
          @keyup.enter.native="searchGoods"
        >
          <el-button slot="append" icon="el-icon-search" @click="searchGoods"></el-button>
        </el-input>
      </div>

      <el-table
        ref="goodsTable"
        :data="goodsList"
        border
        max-height="400"
        v-loading="goodsLoading"
        @selection-change="handleGoodsSelectionChange"
        class="mg-t-20"
      >
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column label="商品名称" min-width="280">
          <template slot-scope="scope">
            <div class="goods-cell">
              <el-image
                v-if="scope.row.image"
                :src="scope.row.image"
                class="goods-image"
                fit="cover"
              ></el-image>
              <div class="goods-name">{{ scope.row.name }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="create_time" width="160" align="center"></el-table-column>
      </el-table>

      <pagination
        v-if="goodsTotal > 0"
        :total="goodsTotal"
        :per_page="goodsPageSize"
        :current_page="goodsPage"
        @handleCurrentChange="handleGoodsPageChange"
        @handleSizeChange="handleGoodsPageSizeChange"
      />

      <span slot="footer" class="dialog-footer">
        <el-button @click="goodsDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmGoodsSelection">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pagination from '../../../components/pagination.vue'

export default {
  name: 'AddCommentShareRule',
  components: {
    pagination
  },
  data() {
    return {
      isEdit: false,
      ruleId: null,
      form: {
        rule_name: '',
        description: '',
        status: 0
      },
      rules: {
        rule_name: [
          { required: true, message: '请输入规则名称', trigger: 'blur' },
          { min: 1, max: 255, message: '长度在 1 到 255 个字符', trigger: 'blur' }
        ]
      },
      selectedGoods: [],
      submitting: false,

      // 商品选择弹窗
      goodsDialogVisible: false,
      goodsKeyword: '',
      goodsList: [],
      goodsLoading: false,
      goodsPage: 1,
      goodsPageSize: 10,
      goodsTotal: 0,
      tempSelectedGoods: []
    }
  },
  created() {
    const { id } = this.$route.query
    if (id) {
      this.isEdit = true
      this.ruleId = id
      this.loadRuleDetail()
    }
  },
  methods: {
    async loadRuleDetail() {
      try {
        const result = await this.$api.commentShareRule.getDetail(this.ruleId)
        this.form = {
          rule_name: result.rule_name,
          description: result.description || '',
          status: result.status
        }
        // 处理关联商品
        if (result.goods && result.goods.length > 0) {
          this.selectedGoods = result.goods.map(item => {
            const goods = item.goods || {}
            return {
              uuid: item.goods_id || goods.uuid,
              name: goods.name || item.goods_name || '',
              image: goods.image || '',
              specs: goods.specs || []
            }
          })
        }
      } catch (error) {
        console.error(error)
        this.$message.error('加载规则详情失败')
        this.$router.back()
      }
    },

    openGoodsDialog() {
      this.goodsDialogVisible = true
      this.goodsKeyword = ''
      this.goodsPage = 1
      this.tempSelectedGoods = [...this.selectedGoods]
      this.searchGoods()
    },

    async searchGoods() {
      this.goodsLoading = true
      try {
        // 使用通用商品列表接口
        const baseURL = process.env.VUE_APP_API_BASE_URL
        const response = await this.axios({
          method: 'get',
          headers: {
            'Content-Type': 'application/json',
            'X-Access-Token': this.storage.get('__token'),
            'Authorization': `Bearer ${this.storage.get('__token')}`
          },
          url: `${baseURL}/v1/cms/Goods`,
          params: {
            search_keyword: this.goodsKeyword,
            page_index: this.goodsPage,
            page_size: this.goodsPageSize,
            status: 1,       // 只查询上架商品
            sale_status: 1   // 只查询在售商品
          }
        })
        const result = response.data.result
        // 转换数据格式，保留规格和创建时间
        this.goodsList = (result.data || []).map(item => ({
          uuid: item.uuid,
          name: item.name,
          image: item.image && item.image.length > 0 ? item.image[0].image : '',
          specs: item.specs || [],
          create_time: item.create_time || ''
        }))
        this.goodsTotal = result.total || 0

        // 设置已选中的商品
        this.$nextTick(() => {
          if (this.$refs.goodsTable) {
            this.goodsList.forEach(row => {
              const isSelected = this.tempSelectedGoods.some(g => g.uuid === row.uuid)
              if (isSelected) {
                this.$refs.goodsTable.toggleRowSelection(row, true)
              }
            })
          }
        })
      } catch (error) {
        console.error(error)
        this.$message.error('搜索商品失败')
      } finally {
        this.goodsLoading = false
      }
    },

    handleGoodsSelectionChange(selection) {
      // 更新临时选中列表
      // 移除当前页取消选中的商品
      const currentPageUuids = this.goodsList.map(g => g.uuid)
      this.tempSelectedGoods = this.tempSelectedGoods.filter(g => !currentPageUuids.includes(g.uuid))
      // 添加当前页选中的商品
      selection.forEach(item => {
        if (!this.tempSelectedGoods.some(g => g.uuid === item.uuid)) {
          this.tempSelectedGoods.push({
            uuid: item.uuid,
            name: item.name,
            image: item.image,
            specs: item.specs || []
          })
        }
      })
    },

    handleGoodsPageChange(page) {
      this.goodsPage = page
      this.searchGoods()
    },

    handleGoodsPageSizeChange(size) {
      this.goodsPageSize = size
      this.goodsPage = 1
      this.searchGoods()
    },

    confirmGoodsSelection() {
      this.selectedGoods = [...this.tempSelectedGoods]
      this.goodsDialogVisible = false
    },

    removeGoods(index) {
      this.selectedGoods.splice(index, 1)
    },

    // 格式化规格对象为字符串，如 {"净含量": "50g*2瓶"} => "净含量: 50g*2瓶"
    formatSpecObj(specObj) {
      if (!specObj) return '-'
      if (typeof specObj === 'string') return specObj
      if (typeof specObj === 'object') {
        const result = []
        for (const key in specObj) {
          // 跳过数字索引键（如 "0", "1", "2"）
          if (/^\d+$/.test(key)) continue
          const value = specObj[key]
          if (value && typeof value !== 'object') {
            result.push(`${key}: ${value}`)
          }
        }
        return result.length > 0 ? result.join(', ') : '-'
      }
      return '-'
    },

    async handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return

        if (this.selectedGoods.length === 0) {
          this.$message.warning('请至少选择一个商品')
          return
        }

        try {
          this.submitting = true

          const params = {
            rule_name: this.form.rule_name,
            description: this.form.description,
            status: this.form.status,
            goods_ids: this.selectedGoods.map(item => item.uuid)
          }

          if (this.isEdit) {
            await this.$api.commentShareRule.update(this.ruleId, params)
            this.$message.success('更新成功')
          } else {
            await this.$api.commentShareRule.create(params)
            this.$message.success('创建成功')
          }

          this.$router.push('/commentShareRuleList')
        } catch (error) {
          console.error(error)
          this.$message.error(this.isEdit ? '更新失败' : '创建失败')
        } finally {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style scoped>
.addCommentShareRule {
  background: #f2f2f2;
  min-height: 100%;
}

.boxLayout {
  padding: 20px;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-top: 20px;
}

.title-t {
  font-size: 16px;
  font-weight: bold;
  border-left: 3px solid #409eff;
  padding-left: 10px;
}

.tips {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}

.goods-cell {
  display: flex;
  align-items: center;
}

.goods-image {
  width: 50px;
  height: 50px;
  margin-right: 10px;
  border-radius: 4px;
}

.goods-name {
  flex: 1;
}

.goods-uuid {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}

.goods-search {
  margin-bottom: 10px;
}

>>> .el-dialog__body {
  padding: 20px;
}

.text-gray {
  color: #999;
  font-size: 12px;
}

.mg-r-5 {
  margin-right: 5px;
}

.mg-b-5 {
  margin-bottom: 5px;
}

.spec-item {
  margin-bottom: 5px;
}

.spec-item:last-child {
  margin-bottom: 0;
}

.spec-tag {
  display: inline-block;
  background: #f4f4f5;
  color: #909399;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
  margin-right: 5px;
}
</style>
